import { isObjectEmpty } from '../common/utils/productCardProps';
export const validateLoungeAvailabilityTranslation = availabilityProps => {
  try {
    if (isObjectEmpty(availabilityProps)) {
      return false;
    }
    const {
      availabilityCard,
      drawer,
      cart
    } = availabilityProps;
    if (isObjectEmpty(availabilityCard) || isObjectEmpty(drawer) || isObjectEmpty(cart)) {
      return false;
    }
    const {
      availabilityTitle,
      departing,
      return: returnKey,
      availableStatus,
      unavailableStatus,
      addedStatus,
      statusTooltip,
      addedTitle,
      seeAll
    } = availabilityCard;
    const {
      terminal,
      openningFrom,
      openningTo,
      oppeningTitle,
      amenities,
      location,
      condition
    } = drawer;
    const {
      purchasedMessage
    } = cart;
    return Boolean(availabilityTitle && departing && returnKey && availableStatus && unavailableStatus && addedStatus && statusTooltip && addedTitle && seeAll && openningFrom && openningTo && oppeningTitle && amenities && location && condition && terminal && purchasedMessage);
  } catch (error) {
    return false;
  }
};
//# sourceMappingURL=utils.js.map